/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import {
  Alert, Box, IconButton,
  LinearProgress, Menu, MenuItem, Pagination, Select, Snackbar, Stack, TextField,
} from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  DeleteOutlined,
  EditOutlined, ExpandMoreRounded,
  MoreHoriz, RemoveCircleOutlineOutlined, Search, VisibilityOutlined,
} from '@mui/icons-material';
// import moment from 'moment';
import moment from 'moment';
import Elements from '../../../Elements';
// import ROUTES from '../../../../Configs/routes';
import { getCustomers } from '../../../../Redux/Models/customer';
import Images from '../../../../Configs/images';
import { OverviewCard } from '../Overview/Overview';
import ROUTES from '../../../../Configs/routes';

export default function AllCustomers({
  classes, customers,
  totalPage = 1, currentPage = 1, isLoading, customerOverview,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const { devId } = useParams();

  const [status, setStatus] = useState('all');
  const [keyword, setKeyword] = useState('');
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [sort, setSort] = useState('Newest');

  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const closeSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const getData = () => {
    dispatch(getCustomers({
      page, limit, sort, type: status, keyword,
    }));
  };

  useEffect(() => {
    getData();
  }, [page, limit, sort, status]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (page === 1) {
        getData();
      } else {
        setPage(1);
      }
    }, 1500);

    return () => clearTimeout(delayDebounceFn);
  }, [keyword]);

  return (
    <Elements.AdminPageBase>
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={snackbar.open} autoHideDuration={10000} onClose={closeSnackbar}>
        <Alert onClose={closeSnackbar} severity={snackbar.severity || 'success'}>
          {snackbar.message}
        </Alert>
      </Snackbar>
      <div className={classes.root}>

        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box fontSize={20}>
            <strong>Customers</strong>
          </Box>
          <Box display="flex" alignItems="center" gap={3}>
            {/* <Box
              display="flex"
              alignItems="center"
              gap={1}
              py={1}
              px={2}
              bgcolor="#FDFDFD"
              borderRadius="10px"
              border="1px solid #E5E5E5"
              className="link"
              fontSize={14}
            >
              <img src={Images.Download} alt="download" height="20" width="20" />
              Download Order Report
            </Box> */}
          </Box>
        </Box>

        <Box mt={3} borderRadius="10px" bgcolor="#FDFDFD" p={2}>
          <Box className="weight-600">Customers Overview</Box>
          <Stack direction="row" spacing={2} mt={2}>
            <OverviewCard
              title="Total Customers"
              value={customerOverview.total_customer}
              percentage={-1}
            />
            <OverviewCard
              title="Total Personal Package"
              value={customerOverview.total_personal_package}
              percentage={-1}
            />
            <OverviewCard
              title="Total Business Package"
              value={customerOverview.total_business_package}
              percentage={-1}
            />
          </Stack>
        </Box>

        <Box mt={2} className="flex gap-16 space-between">
          <Box display="flex" gap={1}>
            <Select
              select
              size="small"
              value={sort}
              onChange={({ target }) => setSort(target.value)}
              IconComponent={ExpandMoreRounded}
              sx={{
                borderRadius: '10px',
                bgcolor: '#fff',
              }}
            >
              <MenuItem value="Oldest">Oldest</MenuItem>
              <MenuItem value="Newest">Newest</MenuItem>
            </Select>
            <Select
              select
              value={status}
              size="small"
              onChange={({ target }) => setStatus(target.value)}
              IconComponent={ExpandMoreRounded}
              sx={{
                borderRadius: '10px',
                bgcolor: '#fff',
              }}
            >
              <MenuItem value="all">All types</MenuItem>
              <MenuItem value="Personal">Personal</MenuItem>
              <MenuItem value="Business">Business</MenuItem>
            </Select>
          </Box>
          <Box display="flex" gap={2}>
            <Select
              select
              size="small"
              value={limit}
              onChange={({ target }) => setLimit(target.value)}
              IconComponent={ExpandMoreRounded}
              sx={{
                borderRadius: '10px',
                bgcolor: '#fff',
              }}
            >
              <MenuItem value={10}>10 List</MenuItem>
              <MenuItem value={20}>20 List</MenuItem>
              <MenuItem value={50}>50 List</MenuItem>
            </Select>
            <TextField
              placeholder="Search by keyword"
              size="small"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              sx={{
                ' .MuiInputBase-root': {
                  bgcolor: '#fff',
                },
              }}
              InputProps={{
                startAdornment: (<Search fontSize="small" sx={{ mr: 1, color: '#D4D4D4' }} />),
              }}
            />
          </Box>
        </Box>

        <Box display="flex" justifyContent="space-between" mt={2}>
          <Box fontSize={12} color="#586479">
            <strong>{customers.length}</strong>
            {' '}
            users
          </Box>
          <Pagination
            count={totalPage}
            variant="outlined"
            shape="rounded"
            size="small"
            page={!isLoading ? currentPage : page}
            siblingCount={0}
            onChange={(e, newPage) => setPage(newPage)}
          />
        </Box>

        {isLoading && <LinearProgress color="inherit" sx={{ mt: 2 }} />}

        <Box mt={3}>
          <table>
            <thead>
              <tr style={{ background: '#2E3C40' }}>
                <td className="white">Customer ID</td>
                <td className="white">Membership</td>
                <td className="white">Name</td>
                <td className="white">Since</td>
              </tr>
            </thead>
            <tbody>
              {customers.map((customer) => (
                <CustomerData customer={customer} key={customer.id} />
              ))}
            </tbody>
          </table>
        </Box>

      </div>
    </Elements.AdminPageBase>
  );
}

function CustomerData({ customer }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <tr key={customer.id}>
      <td>
        <Link to={`${ROUTES.customers()}/detail/${customer.id}`} className="primary-green">
          {customer.id?.slice(0, 5)}
          ...
        </Link>
      </td>
      <td>{customer.customer_type}</td>
      <td>{customer.name}</td>
      <td>{moment(customer.since).format('DD MMM YYYY, HH.mm')}</td>
    </tr>
  );
}
